import { api } from "../config";

export const apiCallsProfileAdmin = {
    Actions: {
        GetDevices: async () => {
            try {   
                const response = await api.get("ProfileAdmin");
                return response.data;
            } catch (error) {
                console.error("API Error:", error.response?.data || error.message);
            }
        },

        GetDevicesForTable: async (page = 0, pageSize = 10) => {
            try {
                const response = await api.get("ProfileAdmin/all-devices", {
                    params : {
                        page : page,
                        pageSize : pageSize
                    }
                });
                return response.data;
            } catch (error) {
                console.error("Api Error:", error.response?.data || error.message);
            }
        },
        
        DeleteDevice: async (deviceId, isGateway) => {
            try {
                const response = await api.request({
                    method: 'DELETE',
                    url: '/ProfileAdmin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem('AuthToken')
                    },
                    data: {
                        id: deviceId,
                        isGateway: isGateway
                    }
                });
                return response;
            } catch (error) {
                console.error("API Error:", error.response?.data || error.message);
            }
        },
        

        GetSiteParams: async (deviceId, type) => {
            try {
                const response = await api.get("ProfileAdmin/site-params", {
                    params: {
                        Id : deviceId,
                        Type : type
                    }
                })
                return response.data;
            } catch (error) {
                console.error("API Error:", error.response?.data || error.message);
            }
        },

        MoveDevice: async (deviceId, lat, lng, type) => {
            try {
                const response = await api.patch("ProfileAdmin/move-device", { 
                    id : deviceId,
                    lat: lat,
                    lng : lng,
                    type : type
                })
                return response;
            } catch (error) {
                console.error("API Error:", error.response?.data || error.message);
            }
        },

        NewDevice: async (device) => {
            try {
                const isGateway = device.type === "gateway";
                const isPillar = device.type === "pillar";
                const isFop = device.type === "fop";
                const response = await api.post("ProfileAdmin/new-device", {
                    deviceName : device.deviceName,
                    deviceUid: device.deviceUID,
                    deviceManufacturer : device.manufacturer,
                    deviceType : device.deviceType,
                    deviceAddress : device.address,
                    deviceLat : device.lat,
                    deviceLng : device.lng,
                    deviceNotes : device.notes,
                    isGateway : isGateway,
                    isPillar : isPillar,
                    isFop: isFop,
                    deviceReplaceType : device.replacedType,
                })
                return response;
            } catch (error) {
                console.error("API Error:", error.response?.data || error.message);
            }
        },

        UpdateDevice: async (device) => {
            try {
                const isGateway = device.type === "gateway";
                const isPillar = device.type === "pillar";
                const isFop = device.type === "fop";
                const response = await api.patch("ProfileAdmin/update-device", {
                    deviceName : device.deviceName,
                    deviceUid: device.deviceUID,
                    deviceType : device.deviceType,
                    deviceAddress : device.address,
                    id : device.deviceId,
                    deviceLat : device.deviceLat,
                    deviceLng : device.deviceLng,
                    deviceManufacturer : device.deviceManufacturer,
                    deviceNotes : device.deviceNotes,
                    isGateway : isGateway,
                    isPillar : isPillar,
                    isFop: isFop,
                    deviceReplaceType : device.replacedType,
                    connectedDevicesIds : device.connections,
                })
                return response;
            } catch (error) {
                console.error("API Error:", error.response?.data || error.message);
            }
        },
    }
}